import { action } from 'satcheljs';

export const onDeleteConversationItemPartsComplete = action(
    'ON_DELETE_CONVERSATION_ITEM_PARTS_COMPLETE'
);
export const toggleRowReadStateComplete = action('TOGGLE_ROW_READ_STATE_COMPLETE');
